<body id="page-top">
  <app-nav-menu *ngIf="headerVisible"></app-nav-menu>
  <div class="app-body">
    <div [ngClass]="headerVisible ? 'app-container': 'login-container'">
      <div class="bco-breadcrumb" *ngIf="headerVisible">
        <app-breadcrumb></app-breadcrumb>
      </div>
      <app-loader></app-loader>
      <app-error></app-error>
      <router-outlet></router-outlet>
    </div>
    <app-footer *ngIf="headerVisible"></app-footer>
  </div>
  <a class="border rounded d-inline scroll-to-top" (click)="goToTopPage()"><i class="fas fa-angle-up"></i></a>
</body>
